import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ServiceStatusState } from '../reducers/service-status.reducer';
import { StateProperty } from '../reducers';

export const serviceStatusSelector = createFeatureSelector<ServiceStatusState>(StateProperty.SERVICE_STATUS);

export const selectServiceStatusIsLoading = createSelector(
  serviceStatusSelector,
  state => state.isLoading
);

export const selectServiceStatusError = createSelector(
  serviceStatusSelector,
  state => state.error
);
